import dayjs from "dayjs";
import { z } from "zod";

export const JournalSectionFormSchema = z.object({
  organization: z.object({
    company: z.object({
      companyId: z
        .string({ required_error: "Укажите организацию" })
        .uuid("Неверный формат ID организации"),
    }),
    projectParticipantId: z
      .string({ required_error: "Укажите участника проекта" })
      .uuid("Неверный формат ID участника проекта"),
  }),
  userCompany: z
    .object({
      userCompanies: z
        .array(
          z.object({
            userCompaniesHistoryId: z
              .string({ required_error: "ID истории обязателен" })
              .uuid("Неверный формат ID истории"),
            shortName: z.string().optional(),
            position: z.string().optional(),
          }),
        )
        .optional(),
      userId: z
        .string({ required_error: "Выберите сотрудника" })
        .uuid("Неверный формат ID сотрудника"),
      userSurname: z.string().optional(),
      userFirstName: z.string().optional(),
      userMiddleName: z.string().optional(),
      userEmail: z.string().optional(),
      userMobilePhone: z.string().optional(),
      userCompanyHistoryId: z.string().optional(),
    })
    .nullable()
    .refine((val) => val !== null, {
      message: "Выберите сотрудника",
    }),

  workType: z
    .string({ required_error: "Укажите вид работ" })
    .min(1, "Укажите вид работ")
    .max(255, "Максимальная длина — 255 символов"),

  startDate: z.any().refine((val) => dayjs.isDayjs(val) && val.isValid(), {
    message: "Укажите дату начала работ",
  }),

  endDate: z
    .any()
    .refine((val) => val === undefined || val === null || (dayjs.isDayjs(val) && val.isValid()), {
      message: "Некорректная дата окончания",
    })
    .nullable()
    .optional(),
  signer: z
    .string({ required_error: "Выберите представителя" })
    .uuid("Неверный формат ID представителя"),

  actionDetails: z.string().optional(),
  status: z.string().optional(),
});

export type JournalSectionFormType = z.infer<typeof JournalSectionFormSchema>;
export type JournalSectionFormInput = z.input<typeof JournalSectionFormSchema>;
